import { 
  Component, 
  EventEmitter, 
  Input, 
  OnInit, 
  Output, 
  ViewChild 
} from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-reminder-email-modal',
  templateUrl: './reminder-email-modal.component.html',
  styleUrls: ['./reminder-email-modal.component.scss']
})
export class ReminderEmailModalComponent implements OnInit {
  @Input() sendRemindEmail: boolean = false;
  @Output() response = new EventEmitter<string>();

  @ViewChild('reminderEmail') public modal: ModalDirective;

  constructor() { }

  ngOnInit() {
  }

  onShown() {
  }

  close() {
    this.modal.hide();
  }

  show() {
    this.modal.show();
  }

  onClickCancel() {
    this.response.emit('cancel');
    this.modal.hide();
  }

  onClickOkay() {
    this.response.emit('okay');
    this.modal.hide();
  }
}
